/**
 * Product-support contact form — boundary contract schema.
 *
 * Owned here: the tenant and landlord support routes (`apps/api/src/routes/tenant/support.routes.ts`,
 * `apps/api/src/routes/manager/support.routes.ts`) register these as the `POST .../support/contact`
 * request body and 200 response, and the landlord UI imports them for the form's field limits, the
 * help-chat escalation prefill (help-center-chatbot DC-6, BR-27) and its client types. One definition,
 * so the limits and the response shape cannot drift apart.
 */
import { z } from 'zod';
/** Max length of the contact form's subject field. */
export const CONTACT_SUBJECT_MAX_CHARS = 255;
/** Max length of the contact form's message field; an escalation draft body never exceeds it (BR-27). */
export const CONTACT_MESSAGE_MAX_CHARS = 5000;
export const ContactRequestSchema = z.object({
    subject: z.string().min(1).max(CONTACT_SUBJECT_MAX_CHARS),
    message: z.string().min(1).max(CONTACT_MESSAGE_MAX_CHARS),
});
/** Response body of `POST .../support/contact`. */
export const ContactResponseSchema = z.object({
    success: z.boolean(),
});
//# sourceMappingURL=contact.js.map